import React, { Component } from 'react'
import Predefine_VnackFull_Soccer from '../components/Predefine_VnackFull_Soccer/Predefine_VnackFull_Soccer'

export class Predefine_VnackFull_SoccerPage extends Component {
  render() {
    return (
      <Predefine_VnackFull_Soccer/>
    )
  }
}

export default Predefine_VnackFull_SoccerPage